<script>
    import { extent } from 'd3-array';
    import { scaleLinear, scaleBand } from 'd3-scale';
    import { monthTickValues, monthFormat, apMonthFormat } from '../utils/d3-utils';

    //components
    import Footnote from './Footnote.svelte';
    import Sourceline from './Sourceline.svelte';
    import ChartHeadline from './ChartHeadline.svelte';
  
    export let data;
    export let tickSize = 4;
    export let width;
    export let height = 240 + tickSize;

    export let title;
    export let footnote;
    export let sourceline;

    let marginTop = 0;
    let marginRight = 0;
    let marginBottom = 20;
    let marginLeft = 0;


    let clusters = [-2.0,-1.6,-1.3,-0.8,-0.5,0.5,0.8,1.3,1.6,2.0]
    
    let colors = [
        '#7b222c',
        '#c26170',
        '#c48237',
        '#deba6a',
        '#f5df8b',
        '#ffffff',
        '#8BD1CC',
        '#3C9E8F',
        '#417CC0',
        '#224795',
        '#272E6E',
    ];

    let colorScheme = scaleLinear()
        .domain(clusters)
        .range(colors);

    let xRange = data.map((d) => d.date);
    let xScale = scaleBand()
      .domain(xRange)
      .range([0, width - marginLeft - marginRight])
      .padding(0);
    let bandwidth = xScale.bandwidth();

    let gradient = `background: linear-gradient(
        90deg,
        #7b222c 9%,
        #c26170 18%,
        #c48237 27%,
        #deba6a 36%,
        #f5df8b 45%,
        #ffffff 54%,
        #8BD1CC 64%,
        #3C9E8F 73%,
        #417CC0 82%,
        #224795 91%,
        #272E6E 100%
    );`;

    let years = [1985, 1990, 1995, 2000, 2005, 2010, 2015, 2020];
    let xTicks = [];
	data.forEach(d => {
		if( (d.date.getMonth() == 0) && (d.date.getDate() == 5)) {
            if (
                years.includes( d.year )
            ) {
                xTicks.push(d.date);
            }
		}
	})

	let xLabel = (x) => 
		x.getFullYear()

</script>

<ChartHeadline text={title} />

<div class="stripes-legend">
    <div class="gradient" style="{gradient}"></div>
    <div class="labels">
        <span>Drier</span>
        <span>Wetter</span>
    </div>
</div> 

<div class="inner-container" bind:clientWidth={width}>
    <svg {width} {height} role="graphics-document" aria-labelledby="Drought stripes">
        <g data-length="{data.length}">
            {#each data as d, idx}
            <rect
                x={xScale(d.date)}
                width={bandwidth}
                y={marginTop}
                height={height - marginTop - marginBottom}
                fill={colorScheme(d.spei)}
                stroke={colorScheme(d.spei)}
                stroke-width=0.1
            />
            {/each}
        </g>
        <g class="axes">
            <g class="axis axis--x" transform="translate(0, {height- marginTop - marginBottom})">
            
                {#each xTicks as x} 
                    <g class="tick" opacity="1" transform="translate({xScale(x)},0)">
                        <line stroke="currentColor" y2="6" />
                        <text fill="currentColor" y="9" dy="0.71em" x="-{marginLeft}">
                            {xLabel(x)}
                        </text>
                    </g>
                {/each}
            </g>
        </g>
        
    </svg>
</div>
{#if footnote}
  <Footnote text={footnote} />
{/if}

{#if sourceline}
  <Sourceline text={sourceline} />
{/if}